module.exports = __webpack_public_path__ + "img/transaction.4e7b340a.png";